import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function ddmmyy(day: number, month: number, year: number): string {
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(day)}/${p(month)}/${p(year % 100)}`
}

/**
 * Formats any date value for display as dd/mm/yy (the app-wide date format).
 * Date-only strings ('YYYY-MM-DD') are rendered as written (no timezone shift);
 * full timestamps and Date objects are rendered in the viewer's local time.
 * Empty/invalid input returns ''.
 */
export function formatDate(value: string | Date | null | undefined): string {
  if (value == null || value === '') return ''
  if (typeof value === 'string') {
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
    if (dateOnly) return ddmmyy(Number(dateOnly[3]), Number(dateOnly[2]), Number(dateOnly[1]))
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return ''
    return ddmmyy(parsed.getDate(), parsed.getMonth() + 1, parsed.getFullYear())
  }
  if (Number.isNaN(value.getTime())) return ''
  return ddmmyy(value.getDate(), value.getMonth() + 1, value.getFullYear())
}
